import React, { PureComponent } from "react";
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Collapse,
  ButtonDropdown,
  ButtonGroup,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { injectIntl } from "react-intl";
import { NotificationManager } from "../../../components/common/react-notifications";

import { Colxx } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../navs/Breadcrumb";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import ThumbListIcon from "../../../components/ThumbListIcon";
import DataListIcon from "../../../components/DataListIcon";
import ModalAddStocks from "./ModalAddStocks";
import ModalAddStocksFromImage from "./ModalAddStocksFromImage";
import TableImport from "./TableImport";
import TableImportSuccess from "./TableImportSuccess";
import TableImportFailed from "./TableImportFailed";
import { exportStockToExcel } from "../../../helpers/stockExport";

const formatDatasExport = (data, intl) => {
  let custs = [];

  for (let i = 0, j = data?.length; i < j; i++) {
    custs.push({
      [intl.formatMessage({ id: "stock.export.stt" })]: i + 1,
      [intl.formatMessage({ id: "stock.export.id" })]: data[i].id,
      [intl.formatMessage({ id: "stock.export.name" })]: data[i].name,
      [intl.formatMessage({ id: "stock.export.sku" })]: data[i].sku,
      [intl.formatMessage({ id: "stock.export.unit" })]: data[i].unit,
      [intl.formatMessage({ id: "stock.export.price_new" })]: data[i].price_new,
      count: "",
      [intl.formatMessage({ id: "stock.export.inventory" })]: data[i].count,
      [intl.formatMessage({ id: "stock.export.total" })]: data[i].total,
      [intl.formatMessage({ id: "stock.export.created_at" })]:
        data[i].createdAt,
      [intl.formatMessage({ id: "stock.export.updated_at" })]:
        data[i].updatedAt,
    });
  }
  return custs;
};

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = ({ csvData, fileName }) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class PageHeading extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownSplitOpen: false,
      isOpenUnifiedModal: false,
      activeAddTab: "2", // Mặc định mở Tab 2 (Thêm nguyên liệu)
      dataImport: [],
    };
  }

  handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        const mappedData = jsonData.map((item) => ({
          name: item["name"] || item["Tên nguyên liệu"],
          barcode: item["barcode"] || item["Barcode"],
          unit: item["unit"] || item["Đơn vị"],
          supplier: item["supplier"] || item["Nhà cung cấp"],
          quantity: item["quantity"] || item["Số lượng"] || item["count"],
          price: item["price"] || item["Đơn giá"] || item["price_new"],
          paid: item["paid"] || item["Đã trả"],
          expiry_date: item["expiry_date"] || item["Hạn sử dụng"],
          category_name:
            item["category_name"] || item["Danh mục"] || item["category"],
          warehouse_name:
            item["warehouse_name"] || item["Kho"] || item["warehouse"],
          min_stock_threshold:
            item["min_stock_threshold"] ||
            item["Tồn tối thiểu"] ||
            item["minimum_stock"],
          batch_code: item["batch_code"] || item["Mã lô"] || item["lot_code"],
          storage_location:
            item["storage_location"] ||
            item["Vị trí lưu kho"] ||
            item["storage_bin"],
          stock_note:
            item["stock_note"] || item["Ghi chú nhập kho"] || item["Ghi chú"],
        }));

        this.setState({ dataImport: mappedData });
      };
      reader.readAsArrayBuffer(file);
    }
  };

  handleDownloadData = () => {
    exportStockToExcel({
      data: this.props.data,
      intl: this.props.intl,
    });
  };

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  toggleDisplayOptions = () => {
    this.setState((prevState) => ({
      displayOptionsIsOpen: !prevState.displayOptionsIsOpen,
    }));
  };

  toggleUnifiedModal = () => {
    this.setState({
      ...this.state,
      isOpenUnifiedModal: !this.state.isOpenUnifiedModal,
      dataImport: [],
      activeAddTab: "2", // Mặc định mở Tab 2 (Thêm nguyên liệu)
    });
  };

  setActiveAddTab = (tab) => {
    if (this.state.activeAddTab !== tab) {
      this.setState({ activeAddTab: tab, dataImport: [] });
    }
  };

  handleDownloadSample = () => {
    const sampleData = [
      {
        name: "Cà phê hạt",
        barcode: "8930010101",
        unit: "kg",
        supplier: "NCC A",
        quantity: 10,
        price: 150000,
        paid: 0,
        expiry_date: "2025-12-31",
        category_name: "Nguyên liệu cà phê",
        warehouse_name: "Kho chính",
        min_stock_threshold: 5,
      },
      {
        name: "Sữa tươi",
        barcode: "8930010102",
        unit: "hộp",
        supplier: "NCC B",
        quantity: 20,
        price: 35000,
        paid: 35000,
        expiry_date: "2025-10-20",
        category_name: "Nguyên liệu pha chế",
        warehouse_name: "Kho chính",
        min_stock_threshold: 10,
      },
    ];
    const fileName = "Mau_nhap_nguyen_lieu";
    exportToCSV({ csvData: sampleData, fileName });
  };

  render() {
    const { messages } = this.props.intl;
    const {
      heading,
      hide_button_add,
      setting,
      match,
      totalItem,
      toggleFunc,
      isDisabledAdd,
      changePageSizeFunc,
      onSearchKeyFunc,
      displayMode,
      changeDisplayMode,
      handleChangeSelectAll,
      selectedItemsLength,
      itemsLength,
      handleImportStock,
      successfulImports,
      failedImports,
      data_all,
      data_providers,
      onHandlerDelete,
    } = this.props;

    const startIndex = (setting.currentPage - 1) * setting.selectedPageSize;
    const endIndex = setting.currentPage * setting.selectedPageSize;

    const { displayOptionsIsOpen, dataImport, activeAddTab } = this.state;
    return (
      <Row className="list-page-heading__row">
        <Colxx xxs="12">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center">
              <h1 className="mb-0 mr-2">
                <IntlMessages id={heading} />
              </h1>
              <Breadcrumb match={match} />
            </div>
            <div className="text-zero top-right-button-container d-flex align-items-center">
              <Button
                color="outline-primary"
                className="mr-2 excel-export-pages top-right-button"
                onClick={this.handleDownloadData}
                title={this.props.intl.formatMessage({
                  id: "page.heading.excel.tooltip",
                })}
              >
                <i className="simple-icon-cloud-download mr-1" />
                <IntlMessages id="page.heading.excel" />
              </Button>

              <ButtonGroup>
                <Button
                  color="primary"
                  className={classnames("top-right-button position-relative", {
                    disable: hide_button_add,
                  })}
                  onClick={() => {
                    if (hide_button_add) {
                      NotificationManager.error(
                        "Gói cước hiện tại của bạn đã đạt giới hạn tạo mới nguyên vật liệu. Vui lòng nâng cấp để thêm mới!",
                        "Giới hạn gói cước",
                        3000,
                        null,
                        null,
                        "",
                      );
                    } else {
                      this.toggleUnifiedModal();
                    }
                  }}
                >
                  <IntlMessages id="pages.add-new" />
                  {hide_button_add ? (
                    <i className="simple-icon-diamond diamond-upgrade-add" />
                  ) : null}
                </Button>

                {/* <div className="btn btn-primary btn-lg pl-4 pr-0 check-button check-all">
                  <CustomInput
                    className="custom-checkbox mb-0 d-inline-block"
                    type="checkbox"
                    id="checkAll"
                    checked={
                      selectedItemsLength >= itemsLength && itemsLength > 0
                    }
                    onChange={() => handleChangeSelectAll(true)}
                    onClick={
                      displayMode !== "thumblist"
                        ? () => changeDisplayMode("thumblist")
                        : null
                    }
                    label={
                      <span
                        className={`custom-control-label ${
                          selectedItemsLength > 0 &&
                          selectedItemsLength < itemsLength
                            ? "indeterminate"
                            : ""
                        }`}
                      />
                    }
                  />
                </div> */}

                {selectedItemsLength > 0 && (
                  <Button
                    color="danger"
                    className="top-right-button"
                    onClick={onHandlerDelete}
                  >
                    <i className="simple-icon-trash mr-1" />
                    <IntlMessages id="pages.delete" /> ({selectedItemsLength})
                  </Button>
                )}
              </ButtonGroup>
            </div>
          </div>

          <div className="mb-2">
            <Button
              color="empty"
              className="pt-0 pl-0 d-inline-block d-md-none"
              onClick={this.toggleDisplayOptions}
            >
              <IntlMessages id="pages.display-options" />{" "}
              <i className="simple-icon-arrow-down align-middle" />
            </Button>
            <Collapse
              isOpen={displayOptionsIsOpen}
              className="d-md-block"
              id="displayOptions"
            >
              <span className=" d-none d-md-flex mr-3 d-inline-block float-md-left ">
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "thumblist" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("thumblist");
                  }}
                >
                  <ThumbListIcon />
                </a>
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "list" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("list");
                  }}
                >
                  <DataListIcon />
                </a>
              </span>
              {displayMode === "list" ? null : (
                <div className="float-md-right">
                  <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${totalItem} `}</span>
                  <UncontrolledDropdown className="d-inline-block">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      {setting.selectedPageSize}
                    </DropdownToggle>
                    <DropdownMenu right>
                      {setting.pageSizes.map((size, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => changePageSizeFunc(size)}
                          >
                            {size}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              )}
            </Collapse>
          </div>
          {/* <Separator /> */}
        </Colxx>
        {/* Unified Add Stock Modal with Tabs */}
        <Modal
          isOpen={this.state.isOpenUnifiedModal}
          toggle={this.toggleUnifiedModal}
          className={classnames("table-modal cursor-pointer max-width-100")}
          size="lg"
        >
          {/* <ModalHeader toggle={this.toggleUnifiedModal}>
            Thêm nguyên liệu mới
          </ModalHeader> */}
          <ModalBody>
            {/* Nút đóng modal */}
            <button
              type="button"
              className="close"
              style={{
                position: "absolute",
                right: 15,
                top: 10,
                zIndex: 1050,
                fontSize: "1.5rem",
                fontWeight: 700,
                opacity: 0.5,
              }}
              onClick={this.toggleUnifiedModal}
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
            <Nav tabs className="mb-3">
              {/* Tab 1: Thêm thủ công - comment out vì Tab 2 đã đầy đủ tính năng
              <NavItem>
                <NavLink
                  className={classnames({ active: activeAddTab === "1" })}
                  onClick={() => this.setActiveAddTab("1")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="simple-icon-plus mr-1" />
                  Thêm thủ công
                </NavLink>
              </NavItem>
              */}
              <NavItem>
                <NavLink
                  className={classnames({ active: activeAddTab === "2" })}
                  onClick={() => this.setActiveAddTab("2")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="simple-icon-layers mr-1" />
                  Thêm nguyên liệu
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeAddTab === "3" })}
                  onClick={() => this.setActiveAddTab("3")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="simple-icon-cloud-upload mr-1" />
                  Nhập từ Excel
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeAddTab === "4" })}
                  onClick={() => this.setActiveAddTab("4")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="simple-icon-picture mr-1" />
                  Nhập từ hình ảnh
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeAddTab}>
              {/* Tab 1: Comment out vì Tab 2 đã đầy đủ tính năng
              <TabPane tabId="1">
                <div className="text-center py-4">
                  <p className="mb-3">
                    Thêm từng nguyên liệu một cách thủ công
                  </p>
                  <Button
                    color="primary"
                    onClick={() => {
                      this.toggleUnifiedModal();
                      toggleFunc();
                    }}
                  >
                    <i className="simple-icon-plus mr-2" />
                    Mở form thêm nguyên liệu
                  </Button>
                </div>
              </TabPane>
              */}
              <TabPane tabId="2">
                {/* Tab 2: Add batch */}
                <ModalAddStocks
                  handleImportStock={handleImportStock}
                  data_all={data_all}
                  data_providers={data_providers || []}
                />
              </TabPane>
              <TabPane tabId="3">
                {/* Tab 3: Import from Excel */}
                <div className="modal-body-import">
                  {successfulImports?.length || failedImports?.length ? (
                    <div className="d-flex flex-column mb-3 w-100">
                      <h5>Kết quả Import</h5>
                      {successfulImports.length > 0 ? (
                        <TableImportSuccess
                          dataSuccess={successfulImports}
                          dataFailed={failedImports}
                        />
                      ) : null}
                      {failedImports.length > 0 ? (
                        <TableImportFailed
                          dataFailed={failedImports}
                          dataSuccess={successfulImports}
                          isFailedTable={true}
                        />
                      ) : null}
                    </div>
                  ) : dataImport.length ? (
                    <div className="d-flex flex-column mb-3 w-100">
                      {/* Reuse ModalAddStocks (Batch Add) for Import Preview */}
                      <ModalAddStocks
                        handleImportStock={handleImportStock}
                        data_all={data_all}
                        data_providers={data_providers || []}
                        initialData={dataImport}
                      />
                    </div>
                  ) : (
                    <div className="text-center py-4 w-50 mx-auto">
                      <p className="mb-3">
                        Chọn file Excel để nhập nguyên liệu
                      </p>
                      <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={this.handleFileUpload}
                        className="form-control-file mb-3"
                      />
                      <div>
                        <Button
                          color="outline-primary"
                          size="sm"
                          onClick={this.handleDownloadSample}
                        >
                          <i className="simple-icon-cloud-download mr-1" />
                          Tải file mẫu
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </TabPane>
              <TabPane tabId="4">
                {/* Tab 4: Add from image */}
                <ModalAddStocksFromImage />
              </TabPane>
            </TabContent>
          </ModalBody>
        </Modal>
      </Row>
    );
  }
}

export default injectIntl(PageHeading);
